/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FullBodyCircleBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M11.997 9c.863 0 1.562-.672 1.562-1.5s-.7-1.5-1.562-1.5c-.862 0-1.561.672-1.561 1.5S11.135 9 11.997 9ZM11.997 14.51l-.756 3.265a.31.31 0 0 1-.302.225H9.66a.305.305 0 0 1-.31-.337l.813-6.3-2.908-.523a.3.3 0 0 1-.25-.35l.23-1.18a.312.312 0 0 1 .365-.24l3.597.648a3.939 3.939 0 0 0 1.606 0l3.597-.647c.17-.03.333.076.364.24l.23 1.179a.301.301 0 0 1-.249.35l-2.908.524.813 6.3a.305.305 0 0 1-.31.336H13.06a.31.31 0 0 1-.302-.225l-.762-3.264Z" /><path fillRule="evenodd" clipRule="evenodd" d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z" /></g></svg>);
const FullBodyCircle = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FullBodyCircleBase} {...rest} ref={ref} />);
export default FullBodyCircle;